import { Helmet } from "react-helmet-async";

const SITE = "BRep";
const BASE_TITLE = "BRep — Every Rep. Better.";
const DEFAULT_DESC =
  "Expert fitness support with no monthly commitment. Choose the service you need — from lift reviews to full training programmes — and receive personalised support from qualified coaches.";

export default function SEO({ title, description, path = "/", image }) {
  const fullTitle = title ? `${title} · ${SITE}` : BASE_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `https://thebrep.app${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
